import React, { useState } from "react";
import { useAuth } from "../auth/authContext";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logo-sevenly.png";
import Menu from "@mui/material/Menu";
import { Link } from "react-router-dom";
import MenuItem from "@mui/material/MenuItem";
import { Avatar, Button } from "@mui/material";
const Header = () => {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const Username = user?.name || "";

  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="d-flex justify-content-between header bg-white align-items-center ">
      <div className="d-flex justify-content-between align-items-center mb-3 mt-3">
        <Link to="/dashboard">
          <img
            src={logo}
            alt="logo"
            style={{
              width: "200px",
              height: "auto",
              padding: "5px",
              cursor: "pointer",
            }}
          />
        </Link>
      </div>

      <div className=" logout-button">
        <div className="d-flex">
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <Avatar sx={{ width: 35, height: 35, fontSize: 22 }}>
              {Username?.charAt(0).toUpperCase()}
            </Avatar>

            <p className="fs-14 fw-700 text-center my-auto p-0 mx-2">
              {Username}
            </p>
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem onClick={handleLogout} className="p-1 mx-4 fs-16">
              Logout
            </MenuItem>
          </Menu>
        </div>
      </div>
    </div>
  );
};

export default Header;
